export default "__VITE_ASSET__R6Mu1RDl__"